import Types from '../Types';

const attemptFindBanners = (payload) => ({
  type: Types.FIND_BANNERS_ATTEMPT,
  payload: payload,
});

const attemptSaveBanner = (payload) => ({
  type: Types.SAVE_BANNER_ATTEMPT,
  payload: payload,
  options: { bannerKey: payload.bannerKey }
});

const attemptRemoveBanner = (payload) => ({
  type: Types.REMOVE_BANNER_ATTEMPT,
  payload: payload,
  options: { bannerKey: payload.bannerKey }
});

export default {
  attemptFindBanners,
  attemptSaveBanner,
  attemptRemoveBanner
};



// WEBPACK FOOTER //
// ./src/redux/banner/bannerActions.js